"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OilNormService = void 0;
class OilNormService {
    constructor(authService, stage) {
        this.authService = authService;
        this.resourceHostId = `cwat-oil-norm-service-${stage}`;
    }
    ;
    async getVehicleOilNorm(vin, language) {
        const url = `api/oil-norm/${vin}?language=${language}`;
        const response = await this.authService.get(this.resourceHostId, url);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
}
exports.OilNormService = OilNormService;
//# sourceMappingURL=OilNormService.js.map